export const OEP_ENTITY = {
    Seasons: 'Seasons',
    Sections: 'Sections',
    Sessions: 'Sessions',
    SessionNominators: 'Session Nominators',
    CommitteeMembers: 'Committee Members',
    Participants: 'Participants',
    Nominations: 'Nominations',
    NominationResponses: 'Nomination Responses',
    CommitteeSelections: 'Committee Selections',
    CommitteeSelectionItems: 'Committee Selection Items',
    ReviewThankYouNotes: 'Review Thank You Notes',
    Presentations: 'Presentations',
    ReviewAssignments: 'Review Assignments',
    Reviews: 'Reviews',
    ReviewResponses: 'Review Responses',
    ReviewQuestions: 'Review Questions',
    ReviewQuestionRubrics: 'Review Question Rubrics',
    ReviewQuestionTypes: 'Review Question Types',
    Conversations: 'Conversations__FeedbackPlatform',
    ConversationMessages: 'Conversation Messages',
    Files: 'MJ: Files',
    FileEntityRecordLinks: 'MJ: File Entity Record Links',
    FileCategories: 'MJ: File Categories',
    UserNotifications: 'MJ: User Notifications',
    TemplateContents: 'MJ: Template Contents',
} as const;
export type OEPEntityName = (typeof OEP_ENTITY)[keyof typeof OEP_ENTITY];

export const OEP_FILE_CATEGORY = { Draft: 'OEP Draft', Final: 'OEP Final' } as const;
export type OEPFileKind = keyof typeof OEP_FILE_CATEGORY;

/**
 * Unqualified ExtraFilter predicates for rows that still take part in the season — shared so the
 * server's audiences and the client's counts agree on "live".
 */
export const OEP_LIVE_FILTER = {
    /** Presentation statuses that still take part in the season (CK_Presentation_Status, V001). */
    Presentation: "Status NOT IN ('Canceled','Archived')",
    /** Assignment statuses that still owe or hold a review (CK_ReviewAssignment_Status, V001). */
    Assignment: "Status NOT IN ('Canceled','Declined')",
} as const;
